import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UserEgiApp } from '@/app/platform/platform-core/user/models/user-egi-app';
import { resolveAppIcon } from '../app-icon.map';

@Component({
    selector: 'egi-app-card',
    templateUrl: './egi-app-card.component.html',
    styleUrls: ['./egi-app-card.component.scss'],
    host: {
        class: 'clickable'
    },
    standalone: false
})
export class EgiAppCardComponent implements OnInit {
  @Input() app: UserEgiApp;

  @HostBinding('class.host-active')
  @Input()
  active: boolean;

  constructor() {}

  ngOnInit(): void {}

  get iconName(): string | undefined {
    return resolveAppIcon(this.app?.name);
  }
}
